import React from "react"
import { Link, graphql } from "gatsby"
import { PrismicRichText } from '@prismicio/react'
import Copyright from '../components/copyright'
import Footer from '../components/footer'
import Contact from '../components/contact'
import Seo from '../components/seo'
import { linkResolver } from '../utils/link_resolver'
import Banner from '../components/banner'
import Header from '../components/header'
import Nav from '../components/nav'
import { GatsbyImage } from 'gatsby-plugin-image'

export const query = graphql`
  query($handle: String) {
    prismicPeoplePage(uid: {eq: $handle}) {
      data {
        body {
          richText
        }
        page_title
        meta_description
        image {
          gatsbyImageData
          alt
        }
        heading {
          text
        }
        photo {
          gatsbyImageData
          alt
        }
      }
    }
  }
`

const People = ({data}) => {
  const entry = data.prismicPeoplePage
  if (!entry) return null
  return (
  <>
    <Seo title={entry.data.page_title} description={entry.data.meta_description} image="" pathname={linkResolver(entry.data)} />  
    <Nav />
    <Header />
    <Banner image={entry.data.image} />
    <div className="w-full font-sans py-12 sm:py-24">
      <div className="w-9/12 mx-auto max-w-screen-2xl">
        <div className="flex-none sm:flex gap-24 justify-between">
          <div className="w-full sm:w-4/12 mt-12 sm:mt-0">
            <GatsbyImage style={{ width: "100%", display: "block", objectFit: "contain" }} image={entry.data.photo.gatsbyImageData} alt={entry.data.photo.alt ? entry.data.photo.alt : ''} />
          </div>
          <div className="w-full sm:w-8/12 prose text-dark-green md:prose-lg leading-relaxed">
            <h1>{entry.data.heading.text}</h1>
            <PrismicRichText field={entry.data.body.richText} />  
          </div>
        </div>
      </div>
    </div>
    <Contact image={entry.data.image} />
    <Footer />
    <Copyright />
  </>
  )
}

export default People